import { date, datetime } from "../../utils";

export const mapCard = (json) => {
    const {
        fileName,
        fileType,
        fiscalYear,
        P01Count,
        P02Count,
        P03Count,
        P04Count,
        P05Count,
        P06Count,
        P07Count,
        P08Count,
        P09Count,
        P10Count,
        P11Count,
        P12Count,
        DocIDate,
        DocFDate,
        DocumentCategory,
        DocType,
        Series,
        TaxEntity,
        NumDocs,
        ID,
        TaxAccountingBasis,
        DateCreated,
        DocIHash,
        P01DocI,
        P02DocI,
        P03DocI,
        P04DocI,
        P05DocI,
        P06DocI,
        P07DocI,
        P08DocI,
        P09DocI,
        P10DocI,
        P11DocI,
        P12DocI,
        P01DocIHash,
        P02DocIHash,
        P03DocIHash,
        P04DocIHash,
        P05DocIHash,
        P06DocIHash,
        P07DocIHash,
        P08DocIHash,
        P09DocIHash,
        P10DocIHash,
        P11DocIHash,
        P12DocIHash,
        POtherDocIHash,
        P01DocF,
        P02DocF,
        P03DocF,
        P04DocF,
        P05DocF,
        P06DocF,
        P07DocF,
        P08DocF,
        P09DocF,
        P10DocF,
        P11DocF,
        P12DocF,
        POtherDocF,
        DocI,
        DocF,
    } = json;

    return [
        [
            {
                labels: ["doc type"],
                value: DocType,
                type: "string",
                align: "left",
                basis: "10%",
            },
        ],
        [{ labels: ["serie"], value: Series, type: "string", align: "center" }],
        [{ labels: ["doc I"], value: DocI, type: "string", align: "left" }],
        [{ labels: ["doc F"], value: DocF, type: "string", align: "left" }],
        [
            {
                labels: ["tax entity"],
                value: TaxEntity,
                type: "string",
                align: "left",
            },
        ],
        [{ labels: ["num docs"], value: NumDocs, type: "string", align: "left" }],
        [{ labels: ["id"], value: ID, type: "string", align: "center" }],
        [
            {
                labels: ["tax accounting basis"],
                value: TaxAccountingBasis,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["date created"],
                value: datetime(DateCreated),
                type: "date",
                align: "center",
            },
        ],
        [{ labels: ["File"], value: fileName, type: "string", align: "left" }],
        [{ labels: ["type"], value: fileType, type: "string", align: "center" }],
        [
            {
                labels: ["doc category"],
                value: DocumentCategory,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["fiscal year"],
                value: fiscalYear,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["01"],
                value: P01Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["02"],
                value: P02Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["03"],
                value: P03Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["04"],
                value: P04Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["05"],
                value: P05Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["06"],
                value: P06Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["07"],
                value: P07Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["08"],
                value: P08Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["09"],
                value: P09Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["10"],
                value: P10Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["11"],
                value: P11Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["12"],
                value: P12Count,
                basis: "5%",
                type: "number",
                align: "center",
            },
        ],
        [
            {
                labels: ["start date"],
                value: date(DocIDate),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["end date"],
                value: date(DocFDate),
                type: "date",
                align: "center",
            },
        ],
        [{ labels: ["doc hash"], value: DocIHash, type: "string", align: "left" }],
        [{ labels: ["01 doc i"], value: P01DocI, type: "string", align: "left" }],
        [{ labels: ["02 doc i"], value: P02DocI, type: "string", align: "left" }],
        [{ labels: ["03 doc i"], value: P03DocI, type: "string", align: "left" }],
        [{ labels: ["04 doc i"], value: P04DocI, type: "string", align: "left" }],
        [{ labels: ["05 doc i"], value: P05DocI, type: "string", align: "left" }],
        [{ labels: ["06 doc i"], value: P06DocI, type: "string", align: "left" }],
        [{ labels: ["07 doc i"], value: P07DocI, type: "string", align: "left" }],
        [{ labels: ["08 doc i"], value: P08DocI, type: "string", align: "left" }],
        [{ labels: ["09 doc i"], value: P09DocI, type: "string", align: "left" }],
        [{ labels: ["10 doc i"], value: P10DocI, type: "string", align: "left" }],
        [{ labels: ["11 doc i"], value: P11DocI, type: "string", align: "left" }],
        [{ labels: ["12 doc i"], value: P12DocI, type: "string", align: "left" }],
        [
            {
                labels: ["01 doc i hash"],
                value: P01DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["02 doc i hash"],
                value: P02DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["03 doc i hash"],
                value: P03DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["04 doc i hash"],
                value: P04DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["05 doc i hash"],
                value: P05DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["06 doc i hash"],
                value: P06DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["07 doc i hash"],
                value: P07DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["08 doc i hash"],
                value: P08DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["09 doc i hash"],
                value: P09DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["10 doc i hash"],
                value: P10DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["11 doc i hash"],
                value: P11DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["12 doc i hash"],
                value: P12DocIHash,
                type: "string",
                align: "left",
            },
        ],
        [
            {
                labels: ["other doc hash"],
                value: POtherDocIHash,
                type: "string",
                align: "left",
            },
        ],
        [{ labels: ["01 doc i"], value: P01DocF, type: "string", align: "left" }],
        [{ labels: ["02 doc i"], value: P02DocF, type: "string", align: "left" }],
        [{ labels: ["03 doc i"], value: P03DocF, type: "string", align: "left" }],
        [{ labels: ["04 doc i"], value: P04DocF, type: "string", align: "left" }],
        [{ labels: ["05 doc i"], value: P05DocF, type: "string", align: "left" }],
        [{ labels: ["06 doc i"], value: P06DocF, type: "string", align: "left" }],
        [{ labels: ["07 doc i"], value: P07DocF, type: "string", align: "left" }],
        [{ labels: ["08 doc i"], value: P08DocF, type: "string", align: "left" }],
        [{ labels: ["09 doc i"], value: P09DocF, type: "string", align: "left" }],
        [{ labels: ["10 doc i"], value: P10DocF, type: "string", align: "left" }],
        [{ labels: ["11 doc i"], value: P11DocF, type: "string", align: "left" }],
        [{ labels: ["12 doc i"], value: P12DocF, type: "string", align: "left" }],
        [
            {
                labels: ["other doc f"],
                value: POtherDocF,
                type: "string",
                align: "left",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

export const header = [
    {
        label: ["Doc. Type"],
        align: "left",
        basis: "10%",
        columnName: "DocType",
        sortable: true,
    },
    { label: ["Serie"], align: "center", columnName: "Series", sortable: true },
    { label: ["Doc I"], align: "left" },
    { label: ["Doc F"], align: "left" },
    {
        label: ["Tax Entity"],
        align: "left",
        columnName: "TaxEntity",
        sortable: true,
    },
    { label: ["Num Docs"], align: "left", columnName: "NumDocs", sortable: true },
    {
        label: ["ID"],
        align: "center",
        columnName: "CLB_ImportID",
        sortable: true,
    },
    {
        label: ["Tax Accounting Basis"],
        align: "left",
        columnName: "TaxAccountingBasis",
        sortable: true,
    },
    { label: ["Date Created"], align: "center" },
    { label: ["File"], align: "left", columnName: "FileName", sortable: true },
    { label: ["Type"], align: "center" },
    {
        label: ["Entity"],
        align: "center",
        columnName: "DocumentCategory",
        sortable: true,
    },
    {
        label: ["Fiscal Year"],
        align: "center",
        columnName: "FiscalYear",
        sortable: true,
    },
    { label: ["1"], align: "center", basis: "5%" },
    { label: ["2"], align: "center", basis: "5%" },
    { label: ["3"], align: "center", basis: "5%" },
    { label: ["4"], align: "center", basis: "5%" },
    { label: ["5"], align: "center", basis: "5%" },
    { label: ["6"], align: "center", basis: "5%" },
    { label: ["7"], align: "center", basis: "5%" },
    { label: ["8"], align: "center", basis: "5%" },
    { label: ["9"], align: "center", basis: "5%" },
    { label: ["10"], align: "center", basis: "5%" },
    { label: ["11"], align: "center", basis: "5%" },
    { label: ["12"], align: "center", basis: "5%" },
    {
        label: ["Start Date"],
        align: "center",
        columnName: "DocIDate",
        sortable: true,
    },
    {
        label: ["End Date"],
        align: "center",
        columnName: "DocFDate",
        sortable: true,
    },
    { label: ["Doc. Type"], align: "left" },
    { label: ["1 Doc I"], align: "left" },
    { label: ["2 Doc I"], align: "left" },
    { label: ["3 Doc I"], align: "left" },
    { label: ["4 Doc I"], align: "left" },
    { label: ["5 Doc I"], align: "left" },
    { label: ["6 Doc I"], align: "left" },
    { label: ["7 Doc I"], align: "left" },
    { label: ["8 Doc I"], align: "left" },
    { label: ["9 Doc I"], align: "left" },
    { label: ["10 Doc I"], align: "left" },
    { label: ["11 Doc I"], align: "left" },
    { label: ["12 Doc I"], align: "left" },
    { label: ["1 Doc I Hash"], align: "left" },
    { label: ["2 Doc I Hash"], align: "left" },
    { label: ["3 Doc I Hash"], align: "left" },
    { label: ["4 Doc I Hash"], align: "left" },
    { label: ["5 Doc I Hash"], align: "left" },
    { label: ["6 Doc I Hash"], align: "left" },
    { label: ["7 Doc I Hash"], align: "left" },
    { label: ["8 Doc I Hash"], align: "left" },
    { label: ["9 Doc I Hash"], align: "left" },
    { label: ["10 Doc I Hash"], align: "left" },
    { label: ["11 Doc I Hash"], align: "left" },
    { label: ["12 Doc I Hash"], align: "left" },
    { label: ["Other Doc Hash"], align: "left" },
    { label: ["1 Doc F"], align: "left" },
    { label: ["2 Doc F"], align: "left" },
    { label: ["3 Doc F"], align: "left" },
    { label: ["4 Doc F"], align: "left" },
    { label: ["5 Doc F"], align: "left" },
    { label: ["6 Doc F"], align: "left" },
    { label: ["7 Doc F"], align: "left" },
    { label: ["8 Doc F"], align: "left" },
    { label: ["9 Doc F"], align: "left" },
    { label: ["10 Doc F"], align: "left" },
    { label: ["11 Doc F"], align: "left" },
    { label: ["12 Doc F"], align: "left" },
    { label: ["Other Doc F"], align: "left" },
];

const repositorymetadataMapper = {
    map: mapper,
    header,
};

export default repositorymetadataMapper;
